import React, { createContext, useContext, useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/config";

const SiteContext = createContext();
export const useSite = () => useContext(SiteContext);

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    logoLight: "",
    logoDark: "",
    favicon: "",
    address: "",
    phone: "12183041383",
    email: "larsonk503@gmail.com",
    social: { facebook: "#", instagram: "#", twitter: "#", youtube: "#", whatsapp: "#", reddit: "#" },
    footerHeading: "About Simple Kindness",
    footerDescription: "Simple Kindness is a mental health resource platform dedicated to breaking the silence and building a compassionate community. I am an advocate of mental health and can provide additional information to support people with a mental health condition or families across North and South Dakota. My advocacy has written for the promise to give a voice to those who need it most. Together, we can create more meaningful change and ensure there are no faces that struggle in isolation.",
  });

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "settings", "site"), (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setSettings((prev) => ({
          ...prev,
          ...data,
          social: { ...prev.social, ...(data.social || {}) },
        }));
        // Dynamically update favicon
        if (data.favicon) {
          let link = document.querySelector("link[rel='icon']");
          if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
          link.href = data.favicon;
        }
        // Update page title if site name set
        if (data.siteName) document.title = data.siteName;
      }
    });
    return unsub;
  }, []);

  return <SiteContext.Provider value={{ settings }}>{children}</SiteContext.Provider>;
};
